const SALES_REPORT_EXPORT_LIMIT = 3000

export const getIsExportLimitReached = (salesReportCount: number) => salesReportCount > SALES_REPORT_EXPORT_LIMIT
